import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppActions from '../app/app_actions';
import { AppConstants } from '../constants/AppConstants';
import { store } from '../store';
import ChangePassword from './account/changePassword.jsx';
import Login from './account/login.jsx';
import logout from './account/logout.jsx';
import ResetPassword from './account/resetPassword.jsx';
import MasterPage from './MasterPage.jsx';
import NotFound from './NotFoundPage.jsx';
import PrivateRoute from './PrivateRoute.jsx';
import Loading from './shared/loading.jsx';
import Notify from './shared/notify.jsx';
import TestMasterPage from './test/TestMasterPage.jsx';
import Whatsnew from './whatsnew.jsx';


class MainReactApp extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[MainReactApp.jsx] ";
        console.log(this.componentName + 'constructor');

        //test per verificare che babelify funzioni ....
        [1, 2, 3].map(provaBabel => provaBabel + 1);

        console.log('\tAppConstants.DEV_MODE: ' + AppConstants.DEV_MODE);
        console.log('\tAppConstants.DEBUG_VIEW: ' + AppConstants.DEBUG_VIEW);
        console.log('\tprocess.env.NODE_ENV: ' + process.env.NODE_ENV);
        console.log('\tReact.version: ' + React.version);
        console.log('\tBoostrap.version: ' + $.fn.tooltip.Constructor.VERSION);

        this.state = {
            windowWidth: window.innerWidth
        };
    }

    componentWillUnmount() {
        console.log(this.componentName + 'componentWillUnmount');
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        console.log(this.componentName + 'componentWillMount');
        window.addEventListener('resize', this.handleResize);

        store.dispatch(AppActions.checkDeviceSize(window.innerWidth));
        //$.armundia = Armundia;
    }

    handleResize() {
        //this.setState({windowWidth: window.innerWidth});
        //console.log("Window Width: " + window.innerWidth);
        //this.setState({windowWidth: window.innerWidth});
        store.dispatch(AppActions.checkDeviceSize(window.innerWidth));
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <>
                <Loading />
                <Notify />
                <Switch>
                    <Redirect exact="true" from="/" to="/login" />

                    <Route path="/login" component={Login} />
                    <Route path="/logout" component={logout} />
                    <Route path="/resetPassword" component={ResetPassword} />
                    <Route path="/changePassword" component={ChangePassword} />
                    <Route path="/whatsnew" component={Whatsnew} />
                    <Route path="/test" component={TestMasterPage} />

                    <PrivateRoute path="/" component={MasterPage} />

                    <Route component={NotFound} />
                </Switch>
            </>
        );
    }
}

export default MainReactApp;